import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NbAccordionModule,
  NbButtonModule,
  NbCheckboxModule,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSelectModule
} from '@nebular/theme';

@Component({
  selector: 'app-survey-actions',
  templateUrl: './survey-actions.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbAccordionModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    NbOptionModule,
    NbCheckboxModule
  ],
  standalone: true
})
export class SurveyActionsComponent {
  @Input() group!: FormGroup;
  @Input() qi!: number;
  @Input() ai!: number;
  @Input() aci!: number;

  @Output() removeAction = new EventEmitter<{ ai: number; aci: number }>();

  public actionTypes = ['show_question', 'open_url_web_view', 'open_url_browser'];
}
